"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-UpdateFormCollections',
    isLoading: 'c-UpdateFormCollections--IsLoading',
    content: 'c-UpdateFormCollections__Content',
    contentSecond: 'c-UpdateFormCollections__Content__second',
    list: 'c-UpdateFormCollections__List',
    menu: 'c-UpdateFormCollections__Menu'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        width: '1000px'
    },
    _a[exports.CSS.isLoading] = {
        display: 'flex',
        'justify-content': 'center'
    },
    _a[exports.CSS.content] = {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around'
    },
    _a[exports.CSS.contentSecond] = {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.list] = {
        'list-style-type': 'none',
        'padding-left': 0
    },
    _a[exports.CSS.menu] = (_b = {
            width: '600px',
            position: 'absolute'
        },
        _b["& .".concat(menu_style_1.CSS.menu)] = {
            right: 'auto',
            width: '100%'
        },
        _b),
    _a);
//# sourceMappingURL=collection.form.modal.style.js.map